import React from 'react';
import noimg from '../../images/no-image.webp';

const Index = ({ ImagePath, ImageAlt = 'ICE Unleashing Power', ImageWidth, ImageHeight, ImageClass, onLoad, onError }) => {
  const imgSrc = ImagePath || noimg;

  return (
     <img
      src={imgSrc}
      alt={ImageAlt}
      width={ImageWidth}
      height={ImageHeight}
      className={ImageClass}
      onLoad={onLoad}
      onError={onError}
    />
  );
};

export default Index;
